import App from 'components/App';
import { routes as group } from 'containers/Group';
import { routes as userDashboard } from 'containers/UserDashboard';
import { routes as student } from 'containers/Student';
import { Config } from 'omni-common-ui';
import styles from 'assets/styles/main.postcss';
import TabNav from 'components/TabNav';

const odinLink = Config.get('odinLink');
const schedulingLink = Config.get('schedulingLink');

export default {
  path: '/',
  component: App,
  appBars: {
    preSticky: {
      'tab-nav': {
        component: TabNav,
        order: 1,
      },
    },
  },
  sidebarColor: styles.colorSideNav,
  sidebar: {
    [odinLink]: {
      order: 0,
      text: 'ODIN+',
    },
    [schedulingLink]: {
      order: 1,
      text: 'Scheduling',
    },
  },
  childRoutes: [
    userDashboard,
    group,
    student,
  ],
};



// WEBPACK FOOTER //
// ./routes.js